import React from 'react';

function Services() {
  const services = [
    {
      icon: 'fas fa-code',
      title: 'Web Development',
      description: 'Custom web applications built with modern technologies and best practices for optimal performance and user experience.',
      gradient: 'from-green-500 to-emerald-600',
    },
    {
      icon: 'fas fa-mobile-alt',
      title: 'Mobile Apps',
      description: 'Native and cross-platform mobile applications that deliver seamless experiences across all devices.',
      gradient: 'from-blue-500 to-indigo-600',
    },
    {
      icon: 'fas fa-cloud',
      title: 'Cloud Solutions',
      description: 'Scalable cloud infrastructure and migration services to help your business grow without limits.',
      gradient: 'from-purple-500 to-pink-600',
    },
    {
      icon: 'fas fa-brain',
      title: 'AI & ML',
      description: 'Intelligent solutions powered by artificial intelligence and machine learning to automate and optimize your processes.',
      gradient: 'from-yellow-500 to-orange-600',
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'Cybersecurity',
      description: 'Comprehensive security solutions to protect your digital assets and ensure business continuity.',
      gradient: 'from-red-500 to-rose-600',
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Data Analytics',
      description: 'Advanced data analysis and visualization tools to turn your data into actionable insights.',
      gradient: 'from-teal-500 to-cyan-600',
    },
  ];

  return (
    <section id="services" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-24">
          <div className="inline-block bg-white px-6 py-3 rounded-full shadow-sm mb-6">
            <span className="text-green-600 font-semibold">Our Services</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6">
            What We <span className="text-gradient">Offer</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprehensive technology solutions tailored to your business needs. We combine innovation with expertise to deliver exceptional results.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="modern-card bg-white p-8 rounded-3xl shadow-lg reveal-element"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`w-20 h-20 bg-gradient-to-br ${service.gradient} rounded-2xl flex items-center justify-center text-white text-3xl mb-6 service-icon`}>
                <i className={service.icon}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
              <a href="#contact" className="text-green-600 font-semibold hover:text-green-700 transition-colors flex items-center gap-2">
                Learn More
                <i className="fas fa-arrow-right"></i>
              </a>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-32 bg-gradient-to-br from-green-500 to-blue-600 rounded-3xl p-12 text-white">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            <div className="reveal-element">
              <div className="text-4xl md:text-5xl font-black mb-2">99.9%</div>
              <div className="text-green-100 text-lg">Uptime Guarantee</div>
            </div>
            <div className="reveal-element" style={{ animationDelay: '0.1s' }}>
              <div className="text-4xl md:text-5xl font-black mb-2">24/7</div>
              <div className="text-green-100 text-lg">Support</div>
            </div>
            <div className="reveal-element" style={{ animationDelay: '0.2s' }}>
              <div className="text-4xl md:text-5xl font-black mb-2">100%</div>
              <div className="text-green-100 text-lg">Secure</div>
            </div>
            <div className="reveal-element" style={{ animationDelay: '0.3s' }}>
              <div className="text-4xl md:text-5xl font-black mb-2">30+</div>
              <div className="text-green-100 text-lg">Technologies</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
